import { Skeleton } from "@/components/ui/Skeleton";

export const RouteFallback = () => (
  <div className="space-y-4 py-8">
    <Skeleton className="h-8 w-1/3" />
    <Skeleton className="h-4 w-1/2" />
    <Skeleton className="h-64 w-full" />
  </div>
);